import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=57d47fa8&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "./upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d47fa8')) {
      api.createRecord('57d47fa8', component.options)
    } else {
      api.reload('57d47fa8', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=57d47fa8&", function () {
      api.rerender('57d47fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provide/customerOrder/upload.vue"
export default component.exports